import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { AchievementDefinitionDto } from "../../../models/achievement/dto/achievement.dto";

export const GET_ACHIEVEMENTS_QUERY_KEY = (organizationId: string) => ['achievements', 'list', organizationId];

export const useListAchievements = (organizationId: string) => {
    const client = useApiClient();

    return useQuery({
        keepPreviousData: true,
        queryKey: GET_ACHIEVEMENTS_QUERY_KEY(organizationId),
        queryFn: () => client.fetchApi<AchievementDefinitionDto[], {}>({
            endpoint: `achievements/admin/${organizationId}`,
            method: 'GET'
        }),
        enabled: !!organizationId,
    });
};
